/* eslint-disable */
import { call, Review } from 'services/api-service'

/**
 * Get translated review data by id and target language
 *
 * @method
 * @name ApiService#getReviewTranslatedData
 * @param {string} locale -
 * @param {string} originSiteKey -
 * @param {integer} id -
 */
function getReviewTranslatedData(parameters: {
  locale: string
  originSiteKey?: string
  id: number
}): Promise<Review> {
  return call<Review>(
    'GET',
    '/sitedata/{siteKey}/translate/review/{id}/{locale}',
    parameters,
    ['locale', 'id'],
    ['originSiteKey'],
    []
  )
}

export default { getReviewTranslatedData }
